function closePopup(event) {
	if (!event) {
		return;
	}

	event.currentTarget.remove('notifications--active');
}

function openPopups() {
	const notifications = Array.from(document.querySelectorAll('.notifications'));

	notifications.map(item => {
		item.classList.add('notifications--active');
		item.addEventListener('click', closePopup)
	});
}

document.addEventListener('DOMContentLoaded', () => {
	openPopups();
}, false);
